


const DETECTION_TOOLS = [
    'Chimera', 'Adoctor', 'DAAP', 'Lint', 'PMD', 
    'Ecoandroid', 'Leafactor', 'Paprika', 'Droidlens', 'xAL',
    'Spotbugs', 'Spotbugs-fbcontrib', 'Infer', 'Detekt'

    
  ];


export { DETECTION_TOOLS };